'use strict';

import template from './object-details-page.html';

export const ObjectDetailsPageComponent = {
	bindings: {},
	controller: ObjectDetailsPageController,
	controllerAs: 'vm',
	template: template,
};

ObjectDetailsPageController.$inject = [
	'$stateParams',
	'mx.shell.ToolbarManager',
	'mx.shell.LeftSidebarService',
	'mx.shell.SideLayout',
	'mx.shell.DetailsView',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.shell.Config',
	'$timeout',
	'mx.shell.AppsService',
	'mx.SolutionBuilderAgent.WidgetManager',
	'mx.shell.EventService',
	'$q',
];
export function ObjectDetailsPageController(
	$stateParams,
	mxToolbarManager,
	leftSidebarService,
	mxSideLayout,
	DetailsView,
	contentWidgetService,
	dialogOpener,
	mxConfig,
	$timeout,
	appService,
	widgetManager,
	eventService,
	$q
) {
	var context = angular.copy($stateParams);
	var vm = this;

	if (context.print === '1') {
		mxToolbarManager.setToolbarVisibility(false);
		leftSidebarService.isVisible = false;

		printPreview(vm, widgetManager, DetailsView, context, $timeout, eventService);
	} else {
		var appName = '';

		var applicationsPromise = appService.getCurrentApplication().then(function () {
			return appService.getApplications();
		});

		var viewsPromise = contentWidgetService.getAllAppViewsUncached(context._type);

		$q.all([applicationsPromise, viewsPromise]).then(function (result) {
			var applications = result[0];
			var widgets = result[1];

			return (
				widgets
					.filter(function (widget) {
						//TODO: get from widget-manager?
						return (!context.widgetId || context.widgetId === widget.Id) && widget.WidgetType === 3;
					})
					.sort(function (widget1, widget2) {
						return widget2.Priority - widget1.Priority;
					})
					.some(function (widget) {
						var viewApps = widget.Applications ? widget.Applications.toLowerCase() : '';

						var appFound =
							viewApps &&
							applications.some(function (app) {
								if (viewApps.indexOf(app.value.toLowerCase()) > -1) {
									appName = app.name;
									return true;
								}
								return false;
							});

						if (appFound) {
							context.widgetId = widget.Id;
							openView(context, mxConfig.settings.basePath, appName);
						}

						return appFound;
					}) || openView(context, mxConfig.settings.basePath)
			);
		});
	}
}

function openView(context, appBasePath, appName) {
	var options = JSON.stringify({
		objectId: context._id,
		dialogId: context.widgetId,
		archived: context._archived === '1' ? '1' : '0',
		type: context._type,
		viewType: 'preview',
	});

	var appPart = appName ? 'app-' + appName : '';

	window.location = appBasePath + appPart + '/?view-options=' + options;
}

async function printPreview(vm, widgetManager, DetailsView, context, $timeout, eventService) {
	context._archived = context._archived === '1';

	vm.view = await widgetManager.getPreviewView(context, context.widgetId);

	eventService.subscribeOnce(mx.shell.EventCodes.AllAjaxComplete, function () {
		print();
		close();
	});
}
